import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'library-card',
  templateUrl: './library-card.component.html',
  styleUrls: ['./library-card.component.scss'],
})
export class LibraryCardComponent {
  @Input() id = '';
  @Input() library = '';
  @Output() closed = new EventEmitter<any>();

  constructor() {}

  close() {
    this.closed.emit(true);
  }
}
